import { MixesValues, Payload, Track, Values } from "../@types/common";
import { ProductsResponse } from "../@types/responses";

const NUMBER = 250000;
export const getPayloadProducts = (
  values: Values,
  data: ProductsResponse
): Payload => {
  let params = {
    ProcessType: "",
    ProcessParam1: "",
    ProcessParam2: "",
    ProcessParam3: "",
    ProcessParam4: "",
    ProcessParam5: "",
    ProcessParam6: "",
  };
  values.tracks.map((track, index) => {
    let pipe = index != 0 ? " | " : "";
    params.ProcessParam4 +=
      pipe +
      data.products
        .find((product) => product.trackName == track.trackName)
        ?.paymentScheduleList.find(
          (obj) => obj.scheduleId.toString() == track.scheduleId
        )?.scheduleName;
    params.ProcessParam6 += pipe + track.trackName;
  });
  const tempValues: Track[] = [...values.tracks];
  tempValues.reverse().map((track, index) => {
    let pipe = index != 0 ? " | " : "";
    params.ProcessParam1 += pipe + rangeNumber(Number(track.loanAmount));
    params.ProcessParam2 += pipe + track.period;
    params.ProcessParam3 += pipe + track.interestRate;
  });
  params.ProcessType = "מחשבון משכנתא מורחב";
  params.ProcessParam5 += values.tracks.length.toString();
  return params;
};
export function rangeNumber(value:number){
  const minNum = Math.floor(value/NUMBER)*NUMBER;
  return `${minNum}-${minNum+NUMBER}`;
}
export const getPayloadMixes = (values: MixesValues): Payload => {
  const value = rangeNumber(Number(values.mortgageSum));
  return {
    ProcessType: "מחשבון משכנתא מקוצר",
    ProcessParam1: value,
    ProcessParam2: values.period.toString(),
    ProcessParam3: "na",
    ProcessParam4: "na",
    ProcessParam5: "1",
    ProcessParam6: "na",
  };
};